/**
 * 돌봄서비스 관련 상수 및 설정
 * CareList 컴포넌트에서 사용하는 이미지와 설정을 중앙에서 관리합니다.
 */

// 서비스 아이콘 이미지
import img1 from '../assets/newImage/care1.svg';
import img2 from '../assets/newImage/care2.svg';
import img3 from '../assets/newImage/care3.svg';
import img4 from '../assets/newImage/care4.svg';
import img5 from '../assets/newImage/care5.svg';
import img6 from '../assets/newImage/care6.svg';
import img7 from '../assets/newImage/care7.svg';

// UI 아이콘
import listIcon from '../assets/list.png';
import iconTel from '../assets/icon_tel.png';

// 기타 이미지
import care24 from '../assets/care24.png';

/**
 * 서비스별 이미지 설정
 * 각 서비스 번호에 따라 표시할 이미지와 스타일을 정의합니다.
 * - width, top, right: 데스크톱 설정
 * - mobileWidth, mobileTop, mobileRight: 모바일 설정 (767px 이하)
 */
const baseConfig = {
  width: '130px',
  top: '-50px',
  right: '10px',
  mobileWidth: '70px',
  mobileTop: '-70px',
  mobileRight: '10px',
};

export const backgroundImages = {
  1: { ...baseConfig, image: img1 },
  2: { ...baseConfig, image: img2 },
  3: { ...baseConfig, image: img3 },
  4: {
    width: '90px',
    top: '-50px',
    right: '10px',
    mobileWidth: '60px',
    mobileTop: '-60px',
    mobileRight: '10px',
    image: img4,
  },
  5: { ...baseConfig, image: img5 },
  6: { ...baseConfig, image: img6 },
  7: { ...baseConfig, image: img7 },
};

// 개별 이미지 export
export { listIcon, iconTel, care24 };

/**
 * 섹션별 특수 렌더링 설정
 * 특정 서비스의 특정 섹션에서 일반 리스트가 아닌 특수 UI를 렌더링해야 할 때 사용합니다.
 *
 * type 종류:
 * - 'payment-table': 본인부담금 이미지 테이블
 * - 'website-link': 외부 사이트 링크 버튼
 */
export const sectionConfig = {
  2: {
    4: { type: 'payment-table' }, // 노인장기요양 - 본인부담금
  },
  5: {
    5: { type: 'website-link' }, // 사회주택 - 관련 사이트
  },
};

/**
 * 상담문의 페이지 번호
 * 메뉴가 추가되면 이 값을 변경하면 됩니다.
 */
export const CONTACT_PAGE_NO = '8';
